import type { ServiceEventType } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): {
    EVENT_TYPE_FIELD_LABEL: string;
    EVENT_TYPE_IS_REQUIRED: string;
    EVENT_TYPE_LABELS: Record<ServiceEventType, string>;
} => {
    const t = useTranslate('eventTypeField');

    return {
        EVENT_TYPE_FIELD_LABEL: t('eventTypeFieldLabel'),
        EVENT_TYPE_IS_REQUIRED: t('eventTypeIsRequired'),
        EVENT_TYPE_LABELS: {
            CALIBRATED: t('calibrated'),
            INSPECTED: t('inspected'),
            REPLACED: t('replaced'),
            SERVICED: t('serviced')
        }
    };
};

export default useTranslation;
